var map = {
	"./1.png": 8986,
	"./2.png": 5890,
	"./3-4.png": 8788,
	"./5-8.png": 200,
	"./home.png": 2346,
	"./players.png": 2767,
	"./teams.png": 6863,
	"./tournaments.png": 3164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1165;